import {isChina} from "@/utils/user";
let isZh = isChina()

const zh_menus = [
    {to: "/app/dashboard", text: isZh ? "首页" : "Dashboard", icon: "wq-dashboard"},
    {to: "/app/sieve/1000/batch", text: "智能空号检测", domestic: true, icon: "wq-sieve"},
    {to: "/app/sieve/101", text: "实时空号检测", domestic: true, icon: "wq-realtime", children : [
        {to: "/app/sieve/1010/single", text: "单条检测", key: "s1010"},
        {to: "/app/sieve/1010/batch", text: "批量检测", key: "s1010"}
    ]},
    {to: "/app/sieve/102", text: "黑名单检测", domestic: true, icon: "wq-blacklist", children : [
        {to: "/app/sieve/1020/single", text: "单条检测", key: "s1020"},
        {to: "/app/sieve/1020/batch", text: "批量检测", key: "s1020"}
    ]},
    {to: "/app/sieve/103", text: "携号转网检测", domestic: true, icon: "wq-trans", children : [
        {to: "/app/sieve/1030/single", text: "单条检测", key: "s1030"},
        {to: "/app/sieve/1030/batch", text: "批量检测", key: "s1030"}
    ]},
    {to: "/app/sieve/104", text: "号码Plus检测", domestic: true, icon: "wq-chanpin", children : [
        {to: "/app/sieve/1040/single", text: "单条检测", key: "s1040"},
        {to: "/app/sieve/1040/batch", text: "批量检测", key: "s1040"}
    ]},
    {to: "/app/sieve/105", text: "号码归属检测", domestic: true, icon: "wq-chanpin", children : [
        {to: "/app/sieve/1050/single", text: "单条检测", key: "s1050"},
        {to: "/app/sieve/1050/batch", text: "批量检测", key: "s1050"}
    ]},
    {to: "/app/sieve/106", text: "机型检测", domestic: true, icon: "wq-chanpin", children : [
        {to: "/app/sieve/1060/single", text: "单条检测", key: "s1060"},
        {to: "/app/sieve/1060/batch", text: "批量检测", key: "s1060"}
    ]}
]

const international_menus = [
    {to: "/app/dashboard", text: isZh ? "首页" : "Dashboard", icon: "wq-dashboard"},
    {to: "/app/sieve/normal", text: isZh ? "普通检测" : "Normal Filter", icon: "wq-sieve", children : [
        {to: "/app/sieve/normal/2280", text: isZh ? "空号检测" : "Unoccupied Filter", key: "s2080"},
        {to: "/app/sieve/normal/2000", text: isZh ? "状态检测" : "State Filter", key: "s2000"},
        {to: "/app/sieve/normal/2001", text: isZh ? "活跃检测" : "Active Filter", key: "s2001"},
        {to: "/app/sieve/normal/2649", text: isZh ? "北美运营商筛查" : "America Operator Filter", key: "s2649"},
        {to: "/app/sieve/normal/2659", text: isZh ? "全球运营商筛查" : "Global Operator Filter", key: "s2659"}
    ]},
    {to: "/app/sieve/opened", text: isZh ? "开通检测" : "App Opened Filter", icon: "wq-opened", children: [
        {to: "/app/sieve/opened/create", text: isZh ? "立即检测" : "Filter immediately", key: "opened_create"},
        {to: "/app/sieve/opened/list", text:  isZh ? "检测记录" : "Filter Record", key: "opened_list"},
    ]},
    {to: "/app/sieve/active", text: isZh ? "活跃检测" : "App Active Filter", icon: "wq-huoyue", children: [
        {to: "/app/sieve/active/create", text: isZh ? "立即检测" : "Filter immediately", key: "active_create"},
        {to: "/app/sieve/active/list", text: isZh ? "检测记录" : "Filter Record", key: "active_list"},
    ]},
    {to: "/app/sieve/senior", text: isZh ? "性别年龄检测" : "Gender & Age Filter", icon: "wq-gender", children: [
        {to: "/app/sieve/senior/create", text: isZh ? "立即检测" : "Filter immediately", key: "senior_create"},
        {to: "/app/sieve/senior/list", text: isZh ? "检测记录" : "Filter Record", key: "senior_list"},
    ]},

    {to: "/app/sieve/format", text: isZh ? "全格式检测" : "Full Format Filter", icon: "wq-icon-format", children: [
        {to: "/app/sieve/format/create", text: isZh ? "立即检测" : "Filter immediately", key: "format_create"},
        {to: "/app/sieve/format/list", text: isZh ? "检测记录" : "Filter Record", key: "format_list"},
    ]},

    {to: "/app/sieve/email", text: isZh ? "邮箱检测" : "Email Filter", icon: "wq-mail", children: [
        {to: "/app/sieve/email/create", text: isZh ? "立即检测" : "Filter immediately", key: "email_create"},
        {to: "/app/sieve/email/list", text: isZh ? "检测记录" : "Filter Record", key: "email_list"},
    ]},

    {to: "/app/tools", text: isZh ? "号码工具" : "Number Tools", icon: "wq-handle", key: "tools", children : [
        {to: "/app/tools/create/special", text: isZh ? "号段生成号码" : "Generated by Range"},
        {to: "/app/tools/create/random", text: isZh ? "随机生成号码" : "Generated by Random"},
        {to: "/app/tools/usca", text: isZh ? "美国&加拿大号码处理" : "USA & CA Number Filter"},
    ]},
    {to: "/app/finance", text: isZh ? "费用管理" : "Cost Management", icon: "wq-finance", children : [
        {to: "/app/finance/recharge/add", text: isZh ? "充值记录" : "Recharge Record"},
        {to: "/app/finance/recharge/deduct", text: isZh ? "扣值记录" : "Deduct Record"},
        {to: "/app/finance/consume/customer", text: isZh ? "消耗记录" : "Consumption record"}
    ]},
    {to: "/app/notice", text: isZh ? "平台公告" : "Notice", icon: "wq-notice"}
]

export default window._CONFIG.international ? international_menus : zh_menus
